/**
 * Predictive search: hits Shopify's /search/suggest.json endpoint and renders
 * results into the #modalSearch panels using .card-product markup for consistency.
 */
(function () {
  'use strict';

  var input = document.querySelector('[data-predictive-search-input]');
  if (!input) return;

  var resultsWrap = document.querySelector('[data-predictive-search-results]');
  var suggestionsWrap = document.querySelector('[data-predictive-search-suggestions]');
  var productsWrap = document.querySelector('[data-predictive-search-products]');
  var emptyEl = document.querySelector('[data-predictive-search-empty]');
  var timer = null;

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderResults(data, term) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];

    suggestionsWrap.innerHTML = '';
    queries.slice(0, 5).forEach(function (q) {
      var a = document.createElement('a');
      a.href = '/search?q=' + encodeURIComponent(q.text) + '&type=product';
      a.className = 'fw-normal link-underline';
      a.textContent = q.text;
      suggestionsWrap.appendChild(a);
    });

    productsWrap.innerHTML = '';
    products.slice(0, 8).forEach(function (product) {
      var card = document.createElement('div');
      card.className = 'card-product';
      var onSale = product.compare_at_price_max && parseFloat(product.compare_at_price_max) > parseFloat(product.price_max);
      card.innerHTML =
        '<div class="card-product_wrapper">' +
          '<a href="' + product.url + '" class="product-img">' +
            '<img class="img-product" loading="lazy" width="174" height="210" src="' + (product.featured_image ? product.featured_image.url : '') + '" alt="' + escapeHtml(product.title) + '">' +
          '</a>' +
        '</div>' +
        '<div class="card-product_info">' +
          '<a href="' + product.url + '" class="name-product fw-normal link-underline">' + escapeHtml(product.title) + '</a>' +
          '<div class="price-wrap">' +
            '<span class="price-new fw-normal">' + product.price + '</span>' +
            (onSale ? '<span class="price-old fw-normal cl-text-6">' + product.compare_at_price_max + '</span>' : '') +
          '</div>' +
        '</div>';
      productsWrap.appendChild(card);
    });

    if (products.length === 0 && queries.length === 0) {
      resultsWrap.style.display = 'none';
      emptyEl.style.display = '';
      emptyEl.textContent = window.themeVars && window.themeVars.strings ? ('No results found for "' + term + '"') : '';
    } else {
      resultsWrap.style.display = '';
      emptyEl.style.display = 'none';
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function search(term) {
    if (!term) {
      resultsWrap.style.display = 'none';
      emptyEl.style.display = 'none';
      return;
    }
    var url = (window.themeVars && window.themeVars.routes && window.themeVars.routes.predictiveSearch) || '/search/suggest';
    fetch(url + '?q=' + encodeURIComponent(term) + '&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        var contentType = res.headers.get('content-type') || '';
        if (contentType.indexOf('json') === -1) {
          // Fallback endpoint without section_id (some stores/proxies strip it)
          return fetch(url + '?q=' + encodeURIComponent(term) + '&resources[type]=product,query&resources[limit]=8').then(function (r) { return r.json(); });
        }
        return res.json();
      })
      .then(function (data) { renderResults(data, term); })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(timer);
    timer = setTimeout(function () { search(term); }, 300);
  });
})();
